// extracted by mini-css-extract-plugin
module.exports = {"field":"field--Q-1asPaqdS","remove-icon":"remove-icon--3h9aWMMt8r","removeIcon":"remove-icon--3h9aWMMt8r"};